import { isEmpty } from "../../../Utilities/Utils";



//function Formulaire({children,title,handleMouse,handleMouseleave,handlekeyUpgain,onclick,count,setCount,nom,postnom,prenom,sexe,telephone,Image,setNom,setPostnom,setPrenom,setSexe,setImage,setTelephone,setNomcomplet}){
    function Formulaire({recordsexist,Affichage,HandleSubmit,my_enseignant,setMy_enseignant,enseignants,setEnseignants,catdispatch,setCatdispatch,titlecours,children,classe,ponderation,setClasse,setPonderation,title,handleMouse,handleMouseleave,handlekeyUpgain,onclick,cour,setCour,confirmSave,classes,cours}){
      return(
          <>
          <>
  <div className="container py-5">
    {/* En-tête de la page */}
    <div className="row mb-4">
      <div className="col-12 text-center">
        <h2 className="fw-extrabold text-dark mb-2" style={{ letterSpacing: '-1px' }}>
          {title}
        </h2>
        <p className="text-muted">Gérez la répartition des enseignements en quelques clics</p>
      </div>
    </div>

    <div className="row g-4">
      {/* Colonne de Gauche : Configuration */}
      <div className="col-lg-5">
        <div className="card border-0 shadow-sm rounded-4 h-100">
          <div className="card-body p-4">
            <div className="d-flex align-items-center mb-4">
              <div className="bg-primary bg-opacity-10 p-2 rounded-3 me-3">
                <i className="bi bi-sliders2-vertical text-primary fs-4"></i>
              </div>
              <h5 className="card-title fw-bold m-0">Configuration</h5>
            </div>

            <form>
              <div className="mb-4">
                <label className="form-label fw-semibold small text-uppercase text-muted">
                  Distribuer les cours par :
                </label>
                <select 
                  className="form-select form-select-lg border-2 shadow-none" 
                  onChange={(e)=>setCatdispatch(e.target.value)} 
                  value={catdispatch}
                >
                  <option value="" disabled>Sélectionner une catégorie...</option>
                  <option value="classe">🏫 Par classe</option>
                  <option value="cours">📚 Par cours</option>
                </select>
              </div>

              {/* Animation conditionnelle simple via CSS ou Transition Group */}
              {catdispatch === "classe" && (
                <div className="mb-4 animate__animated animate__fadeIn">
                  <label className="form-label fw-semibold small text-uppercase text-muted">
                    Classe cible <span className="text-danger">*</span>
                  </label>
                  <select 
                    className="form-select form-select-lg border-2 border-primary-subtle shadow-none" 
                    onChange={(e)=>setClasse(e.target.value)} 
                    value={classe}
                  >
                    <option value="" disabled>Choisir la classe</option>
                    {classes.map((cla) => (
                      <option value={cla.id} key={cla.id}>{cla.nom}</option>
                    ))}
                  </select>
                </div>
              )}

              {catdispatch === "cours" && (
                <div className="mb-4 animate__animated animate__fadeIn">
                  <label className="form-label fw-semibold small text-uppercase text-muted">
                    Cours spécifique <span className="text-danger">*</span>
                  </label>
                  <select 
                    className="form-select form-select-lg border-2 border-primary-subtle shadow-none" 
                    onChange={(e)=>setCour(e.target.value)} 
                    value={cour}
                  >
                    <option value="" disabled>Choisir le cours</option>
                    {cours.map((crs) => (
                      <option value={crs.id} key={crs.id}>{crs.nom}</option>
                    ))}
                  </select>
                </div>
              )}

              {/* Section Dispatching (Affichage dynamique) */}
              <div className="mt-5 pt-4 border-top">
                <h6 className="fw-bold mb-3">Action de dispatching</h6>
                <div className="bg-light p-3 rounded-3 mb-4 min-vh-25">
                  {Affichage()}
                </div>
                <div id="erreur" className="text-danger bg-light p-2 rounded-3 d-none">
                  
                </div>
                {!isEmpty(catdispatch) && (
                  
                  <button 
                    className="btn btn-primary btn-lg w-100 fw-bold shadow-sm" 
                    type="button" 
                    onClick={confirmSave}
                  >
                    <i className="bi bi-check2-circle me-2"></i> Valider le dispatching
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Colonne de Droite : Visualisation/Liste */}
      <div className="col-lg-7">
        <div className="card border-0 shadow-sm rounded-4 h-100">
          <div className="card-header bg-transparent border-0 p-4 pb-0">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="fw-bold m-0">
                {titlecours}
              </h5>
              <span className="badge bg-dark rounded-pill px-3 py-2">
                Total : {!isEmpty(classe) ? recordsexist.length : 0}
              </span>
            </div>
          </div>
          <div className="card-body p-4">
             {/* Ici on imagine que children contient un tableau ou une liste propre */}
             <div className="table-responsive">
                {children}
             </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</>

          </>
        )
    }
    export default Formulaire;